@use "sass:color";
@use "sass:math";

// Round a Sass color to integer RGB so Dart Sass never emits decimals
// (e.g. rgb(172.46875, …)) which break the `color` npm package at runtime.
@function round-color($c) {
    @return rgb(
        math.round(color.channel($c, "red", $space: rgb)),
        math.round(color.channel($c, "green", $space: rgb)),
        math.round(color.channel($c, "blue", $space: rgb))
    );
}

$primary: #35818B;

$primary_lighter: round-color(color.adjust($primary, $lightness: 40%));
$primary_light: round-color(color.adjust($primary, $lightness: 20%));
$primary_dark: round-color(color.adjust($primary, $lightness: -20%));
$primary_darker: round-color(color.adjust($primary, $lightness: -30%));

$primary_8: #{$primary}14;

:root {
    --primary_lighter: #{$primary_lighter};
    --primary_light: #{$primary_light};
    --primary: #{$primary};
    --primary_dark: #{$primary_dark};
    --primary_darker: #{$primary_darker};

    --primary_8: #{$primary_8};
}

:export {
    primary_lighter: $primary_lighter;
    primary_light: $primary_light;
    primary: $primary;
    primary_dark: $primary_dark;
    primary_darker: $primary_darker;

    primary_8: $primary_8;
}
